import React from 'react';

export const Benefits = (props) => {
  return (
    <>
      <h3 className={`${props.appendText}__benefits-title`}>{props.title}</h3>
      <div className={`${props.appendText}__benefits-section`}>
        <div className={`${props.appendText}__icon-and-description`}>
          <picture>
            <source
              media="(max-width: 799px)"
              srcSet={props.imageOne}
              width="480"
              height="400"
            />
            <source
              media="(min-width: 800px)"
              srcSet={props.imageOne}
              width="800"
              height="400"
            />
            <img
              src={props.imageOne}
              alt="Laptop"
              className={`${props.appendText}__icon`}
              width="800"
              height="400"
            />
          </picture>
          {/* <img
            src={props.imageOne}
            alt="Laptop"
            className={`${props.appendText}__icon`}
          /> */}

          <p className={`${props.appendText}__benefits`}>
            <h4 className={`${props.appendText}__benefits-desc-title`}>
              {props.benefitTitleOne}
            </h4>
            {props.benefitOneJsx}
          </p>
        </div>
        <div className={`${props.appendText}__icon-and-description`}>
          {/* <img
            src={props.imageTwo}
            alt="Diploma"
            className={`${props.appendText}__icon`}
          /> */}
          <picture>
            <source
              media="(max-width: 799px)"
              srcSet={props.imageTwo}
              width="480"
              height="400"
            />
            <source
              media="(min-width: 800px)"
              srcSet={props.imageTwo}
              width="800"
              height="400"
            />
            <img
              src={props.imageTwo}
              alt="Diploma"
              className={`${props.appendText}__icon`}
              width="800"
              height="400"
            />
          </picture>

          <p className={`${props.appendText}__benefits`}>
            <h4 className={`${props.appendText}__benefits-desc-title`}>
              {props.benefitTitleTwo}
            </h4>
            {props.benefitTwo}
          </p>
        </div>
        <div className={`${props.appendText}__icon-and-description`}>
          {/* <img
            src={props.imageThree}
            alt="Globe"
            className={`${props.appendText}__icon`}
          /> */}

          <picture>
            <source
              media="(max-width: 799px)"
              srcSet={props.imageThree}
              width="480"
              height="400"
            />
            <source
              media="(min-width: 800px)"
              srcSet={props.imageThree}
              width="800"
              height="400"
            />
            <img
              src={props.imageThree}
              alt="Globe"
              className={`${props.appendText}__icon`}
              width="800"
              height="400"
            />
          </picture>

          <p className={`${props.appendText}__benefits`}>
            <h4 className={`${props.appendText}__benefits-desc-title`}>
              {props.benefitTitleThree}
            </h4>
            {props.benefitThree}
          </p>
        </div>
      </div>
    </>
  );
};
